import { Box, Icon } from "@outschool/backpack";
import { fasStar } from "@outschool/icons";
import { Image } from "@outschool/ui-legacy-component-library";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import React from "react";

import walletIcon from "../../../images/wallet-icon.svg";

export default function WalletIcon({
  showStar = false,
  size = "small",
  alt = ""
}) {
  return (
    <Box
      sx={{
        position: "relative",
        marginLeft: "0.25em",
        marginRight: "0.5em"
      }}
    >
      <Image
        src={walletIcon}
        alt={alt}
        sx={{
          display: "block",
          height: size === "small" ? "23px" : "65px"
        }}
      />
      {showStar && (
        <Icon
          icon={fasStar}
          color="warning"
          sx={{
            fontSize: size === "small" ? "10px" : "29px",
            position: "absolute",
            bottom: 0,
            left: 0,
            transform: "translate(-25%, 10%)"
          }}
        />
      )}
    </Box>
  );
}
